<script>
import { BAlert, BCard, BCardTitle, BLink } from 'bootstrap-vue'
import SubstanceList from "@/views/product/components/product-card/composition/SubstanceList.vue";
import Parents from "@/views/product/components/product-card/composition/Parents.vue";
import {SubstanceState} from "@/libs/product";

export default {
    components: {SubstanceList, Parents, BAlert, BCard, BCardTitle, BLink},
    props: {
        component: {
            required: true,
            type: Object,
        },
        substanceLists: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    computed: {
        alertVariant() {
            const successStates = [
                SubstanceState.ALL_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES,
                SubstanceState.ALL_DEFINED_INCLUDES_SUBSTANCES
            ];

            if (successStates.includes(this.component.state)) {
                return 'success';
            }

            const warningStates = [
                SubstanceState.ALL_UNDEFINED,
                SubstanceState.SOME_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES,
                SubstanceState.SOME_DEFINED_INCLUDES_SUBSTANCES
            ];

            return warningStates.includes(this.component.state) ? 'warning' : 'secondary';
        },
        alertMessage() {
            switch (this.component.state) {
                case SubstanceState.ALL_UNDEFINED:
                case SubstanceState.SOME_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES:
                case SubstanceState.SOME_DEFINED_INCLUDES_SUBSTANCES:
                    return this.$t('Page(ReceivedRequest):Component(ConcernElements):message-not-all-declared');

                case SubstanceState.ALL_DEFINED_DOES_NOT_INCLUDE_SUBSTANCES:
                    return this.$t('Page(ReceivedRequest):Component(ConcernElements):message-all-declared-not-includes');
            }
            return this.$t('Page(ReceivedRequest):Component(ConcernElements):message-all-declared-includes');
        }
    }
}
</script>

<template>
    <b-card no-body border-variant="light">
        <div class="card-header">
            <b-card-title>
                <Parents :component="component"/>
            </b-card-title>
        </div>
        <b-alert
            show
            class="ml-1 mr-1"
            :variant="alertVariant"
        >
            <div class="alert-body">
                {{ alertMessage }}
            </div>
        </b-alert>
        <SubstanceList
            :substances="component.substances"
            :substance-lists="substanceLists"
        />
    </b-card>
</template>
